import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

import Identity from './identity';
import { headers } from './constants';

/**
 * Request to verify the user's email address. The API will create a nonce and trigger an event so that the nonce can be communicated to the user. The user can then call `verifyEmail(nonce)` to complete the email verification flow.
 *
 * @param email
 *
 * @returns
 *
 * <details>
 * <summary>
 * On error (throws)
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/User_Registration/requestEmailVerify
 * ```
 *
 * </details>
 */

export default function requestVerifyEmail(email: string): Promise<boolean | APIErrorResponse> {
  return fetch(`${Identity.apiOrigin}/identity/public/v1/email/verify`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ email })
  })
    .then(JSONResponseHandler)
    .then(json => {
      if (json.success) {
        return true;
      } else {
        throw json;
      }
    });
}
